<template>
  <div>
    <v-col>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="selectedDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedDate"
            :label="label"
            readonly
            v-bind="attrs"
            v-on="on"
            :dark="dark"
          ></v-text-field>
        </template>
        <v-date-picker v-model="selectedDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="emitSelectedDate()">OK</v-btn>
          <v-btn text color="red" @click="menu = false">Cancel</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: "Select Date",
    },
    default: {
      default: new Date().toISOString().substr(0, 10),
    },
    dark: {
      default: false,
    },
  },
  mounted() {
    if (this.default != undefined || this.default != null) {
      this.selectedDate = this.default;
    }
  },
  data() {
    return {
      selectedDate: new Date().toISOString().substr(0, 10),
      menu: false,
    };
  },
  methods: {
    emitSelectedDate() {
      this.$refs.menu.save(this.selectedDate);
      this.$emit("date-selected", this.selectedDate);
    },
  },
};
</script>

<style></style>
